import React from 'react';
import { Link } from 'react-router-dom';

const Support: React.FC = () => {
  return (
    <div className="Page-content">
      <Link to="/" className="Page-back">← back</Link>
      <div className="Support-embed">
        <iframe title="Support contact form" src="https://docs.google.com/forms/d/e/1FAIpQLSfJfyQPxrraxI4x8vaWqJivWxvbfKk2Ad0pl7qBYYVZtDvUag/viewform?embedded=true" width="100%" height="541">
          Loading…
        </iframe>
      </div>
    </div>
  );
};

export default Support;